import DanmarkStrategy from "./danmark";
import NorwayStrategy from "./norway";
import NetherlandsStrategy from "./netherlands";
import SwedenStrategy from "./sweden";
import UKStrategy from "./uk";

const MarketStrategies = {
  NL: NetherlandsStrategy,
  SE: SwedenStrategy,
  GB: UKStrategy,
  DK: DanmarkStrategy,
  NO: NorwayStrategy,
};

export type MarketCodeISO2 = keyof typeof MarketStrategies;

export default MarketStrategies;

export type MarketStrategy =
  | typeof SwedenStrategy
  | typeof NetherlandsStrategy
  | typeof UKStrategy
  | typeof DanmarkStrategy
  | typeof NorwayStrategy;
